module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_3-8ca1448f9ffe75f7ea2cefe9bc96b8d7.png";